import * as moment from "moment-timezone";
import * as queryString from "query-string";
import * as React from "react";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text";
import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import { PageProps } from "src/pages/Router/routes";
import { TabbedNavigation } from "src/library/components/TabbedNavigation";
import PriceChangeProductsTab from "src/core/prices/components/PriceChangeProductsTab";
import PriceChangeDropsTab from "src/core/prices/components/PriceChangeDropsTab";
import {
  PricesRequestName,
  usePricesApi
} from "src/core/prices/api/prices.api";

/**
 * Price changes by date page
 */
const PriceChangeDatesPage: React.ReactFCWithChildren<PageProps<unknown, {priceListId: string}>> = props => {
  const currentPriceCodeId = props.match && parseInt(props.match.params.priceListId, 0);
  const [ listPriceCodeResponse, listPriceCodeRequest ] = usePricesApi(PricesRequestName.GET_PRICE_LIST);
  const params = queryString.parse(props.location.search);

  // set price list data on mount
  React.useEffect(() => {
    if (currentPriceCodeId) {
      listPriceCodeRequest({ priceCodeId: currentPriceCodeId });
    }
  }, [ currentPriceCodeId, listPriceCodeRequest ]);

  return (
    <Layout
      {...props}
      title={`Price Changes - ${params.effectiveDate ? moment.utc(params.effectiveDate).format("ddd D MMM YYYY") : ""}`}
    >
      <MainContentWrapper fill>
        {listPriceCodeResponse.data && (
          <Text as="h4">
            {`Price List: ${listPriceCodeResponse.data.code} ${listPriceCodeResponse.data.name ? " - " + listPriceCodeResponse.data.name : ""}`}
          </Text>
        )}

        <TabbedTableWrapper>
          {currentPriceCodeId && (
            <TabbedNavigation
              defaultTab="products"
              className="tab-navigator"
              tabs={[
                {
                  title: "Products",
                  name: "products",
                  content: () => (
                    <PriceChangeProductsTab
                      {...props}
                      effectiveDate={params.effectiveDate}
                      priceCode={listPriceCodeResponse.data}
                    />
                  )
                },
                {
                  title: "Drops",
                  name: "drops",
                  content: () => (
                    <PriceChangeDropsTab
                      {...props}
                      priceCodeId={currentPriceCodeId}
                    />
                  )
                }
              ]}
            />
          )}
        </TabbedTableWrapper>
      </MainContentWrapper>
    </Layout>
  );
};

export default PriceChangeDatesPage;

const TabbedTableWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spacing.margins.xl};

    .page-desc {
      margin-top: ${theme.spacing.margins.lg};
    }

    .table-content {
      margin-top: ${theme.spacing.margins.lg};
    }
  `}
`;
